/* eslint-disable max-len */
/* eslint-disable quotes */
const defaultScores = {
  "5ed0e9a4f1ae202c11bb1d02": {
    "id": "5ed0e9a4f1ae202c11bb1d02",
    "name": "Fertility",
    "category": "production",
    "significance": "High insemination in-calf success rate and maiden heifers in-calf from 14 months for raising farm productivity and reducing GHG emissions",
    "key": "fertility",
    "scoreCard": [
      {
        "score": 4,
        "definition": "93%+ insemination success rate within an 8 week insemination and calving window, and maiden heifer 1st calving from 24 mths. For a Bull, a Valid Fertility Certificate and an EBV fertility ranking in top 30%"
      },
      {
        "score": 3,
        "definition": "90%+ insemination success rate with an 10 week calving window, with maiden heifer 1st calving from 28 months. For a Bull a Valid Fertility Certificate"
      },
      {
        "score": 2,
        "definition": "87%+insemination success rate with a 15 week calving window. Maiden heifers 1st calving 32  months. For a Bull, an EVB fertility ranking in top 50%"
      },
      {
        "score": 1,
        "definition": "80%+insemination success rate with a 20 week calving window. Maiden heifers 1st calving 36+ months. For a Bull,  no Valid Fertility Certificate or EBV fertility ranking"
      },
      {
        "score": 0,
        "definition": "Less than 80% insemination success rate with a 20+ week calving window. Maiden heifers 1st calving 33+ months. For a Bull, last test failed"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d03": {
    "id": "5ed0e9a4f1ae202c11bb1d03",
    "name": "Calving and Weaning",
    "category": "production",
    "significance": "Unassisted birth, calf  up and suckling and successfully weaned at 6months+. Less than 5% calf loss rate, for optimising farm productivity and reducing GHG emissions",
    "key": "calvingEase",
    "scoreCard": [
      {
        "score": 4,
        "definition": "97%+ Unassisted calvings. 98%+ of calves born successfully weaned."
      },
      {
        "score": 3,
        "definition": "95% Unassisted calvings, with 4%+ easy Easy Pulls and only 1% Mechanically-Aided Pulls or Veterinary intervention. 97% calves born successfully weaned."
      },
      {
        "score": 2,
        "definition": "90% Unassisted calvings, with 5%+ easy Easy Pulls and 5% Mechanically-Aided Pulls or Veterinary Intervention. 95% of calves born successfully weaned."
      },
      {
        "score": 1,
        "definition": "85% Unassisted calvings, with 10%+ easy Easy Pulls and 5% Mechanically-Aided Pulls or Veterinary Intervention. 90% of calves born successfully weaned."
      },
      {
        "score": 0,
        "definition": "Less than 85% Unassisted calvings. Less than 90% of calves born successfully weaned."
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d04": {
    "id": "5ed0e9a4f1ae202c11bb1d04",
    "name": "Growth",
    "category": "production",
    "significance": "Competitive growth with suckled calves and no supplements. Weaned from 9 months, on a grass and wholecrop feed diet for reducing GHG emissions",
    "key": "growthEfficiency",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Weaned calf 50%+ of mature dry cow weight, and sustained 1.3Kg average daily live weight gain (ADLWG) for 100% pasture fed. Ready from 17-18 months."
      },
      {
        "score": 3,
        "definition": "Weaned calf 46%+ of mature dry cow weight, and sustained 1.2Kg average daily live weight gain (ADLWG). Ready from 18 months."
      },
      {
        "score": 2,
        "definition": "Weaned calf 37%+ of mature dry cow weight, and sustained 1.0Kg average daily live weight gain (ADLWG). Ready from 22 months."
      },
      {
        "score": 1,
        "definition": "Weaned calf 33%+ of mature dry cow weight, and sustained 0.9Kg average daily live weight gain (ADLWG). Ready from 24 months."
      },
      {
        "score": 0,
        "definition": "Weaned calf 29%+ of mature dry cow weight, and sustained 0.7Kg average daily live weight gain. Ready at 30 months."
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d05": {
    "id": "5ed0e9a4f1ae202c11bb1d05",
    "name": "Structure",
    "category": "production",
    "significance": "Long loin, well positioned legs and feet, narrower forequarters, fuller rump, scrotum size and shape and smooth locomotion - for trouble-free life",
    "key": "structure",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Excellent physical characteristics for Loin, Legs & Feet, Narrower Shoulders, Broader & Deeper Rump and Smooth Locomotion"
      },
      {
        "score": 3,
        "definition": "Good physical characteristics for Loin, Legs & Feet, Narrower Shoulders, Broader & Deeper Rump and Smooth  Locomotion"
      },
      {
        "score": 2,
        "definition": "Average physical characteristics for Loin, Legs & Feet, Narrower Shoulders, Broader & Deeper Rump and Smooth  Locomotion"
      },
      {
        "score": 1,
        "definition": "Borderline physical characteristics for Loin, Legs & Feet, Narrower Shoulders, Broader & Deeper Rump and Smooth  Locomotion"
      },
      {
        "score": 0,
        "definition": "Borderline physical characteristics for Loin, Legs & Feet, Narrower Shoulders, Broader & Deeper Rump, Smooth  Locomotion and/or structural deficiencies"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d06": {
    "id": "5ed0e9a4f1ae202c11bb1d06",
    "name": "Temperament",
    "category": "production",
    "significance": "Quiet demeanour for lowering stress levels and minimising the risk of injury to staff and other cattle",
    "key": "temperament",
    "scoreCard": [
      {
        "score": 4,
        "definition": "<Fragment><span className=\"highlight\">Docile:</span> Does not pull head on headgate yoke in the crush. Exits the crush calmly</Fragment> "
      },
      {
        "score": 3,
        "definition": "<Fragment><span className=\"highlight\">Restless:</span> Pulls on the headgate yoke in the crush with some tail flicking. Exits promptly</Fragment> "
      },
      {
        "score": 2,
        "definition": "<Fragment><span className=\"highlight\">Manageable:</span> Repeated pushing and pulling on headgate yoke. Exits the crush in a rush</Fragment> "
      },
      {
        "score": 1,
        "definition": "<Fragment><span className=\"highlight\">Flighty:</span> Struggles in headgate yoke. Exits the crush wildly</Fragment> "
      },
      {
        "score": 0,
        "definition": "<Fragment><span className=\"highlight\">Aggressive:</span> Exits the crush frantically and may exhibit attack behaviour when handled alone</Fragment>"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d07": {
    "id": "5ed0e9a4f1ae202c11bb1d07",
    "name": "Size",
    "category": "production",
    "significance": "Medium weight, coupled with high animal weaned animal to dam weights' ratio, for optimising growth performance and reducing GHG emissions.",
    "key": "size",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Mid sized Mature Cows averaging 650-700Kg and 500Kg for 1st Calvers. Calves 35-40kg birth weight620 Kg finished animal at 17 to 18 months."
      },
      {
        "score": 3,
        "definition": "Mature Cows 700-750Kg and calves 38-42Kg birth weight. Finished animal at 18 to to 20 months"
      },
      {
        "score": 2,
        "definition": "Larger Breeding Cows 750-820Kg. Calves 43-45Kg birth weight. Finished animal  15-24 months"
      },
      {
        "score": 1,
        "definition": "Large Breeding Cows 830 -900Kg. Calves 46-48Kg birth weight. Finished animal at 12-30 months"
      },
      {
        "score": 0,
        "definition": "Very large Cows 900Kg+.  Calves over 48Kg birth weight. Finished animal weight below 550Kg or above 750kg"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d08": {
    "id": "5ed0e9a4f1ae202c11bb1d08",
    "name": "Welfare",
    "category": "production",
    "significance": "Regular food supply, clean yards, summer grazing, for well-being and avoiding stress-related gristle",
    "key": "welfare",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Closed sucker beef herd with performance tracking, risk assessments and staff training to assure a high level of animal welfare and to mitigate operational risks for staff."
      },
      {
        "score": 3,
        "definition": "Feed, Fertilising, Health and Breeding protocols, and risk assessments covering operational activities."
      },
      {
        "score": 2,
        "definition": "In addition to Red Tractor requirements, vet-approved Bio-security, Health and Diet plans, to optimise cattle wellbeing"
      },
      {
        "score": 1,
        "definition": "Red Tractor certification for ensuring that cattle welfare practices are adequate"
      },
      {
        "score": 0,
        "definition": "No Red Tractor certification or a comparable certification body."
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d09": {
    "id": "5ed0e9a4f1ae202c11bb1d09",
    "name": "Health",
    "category": "production",
    "significance": "Reduced bacterial, viral, parasitic disease and mineral and vitamin deficiencies, for higher animal performance",
    "key": "health",
    "scoreCard": [
      {
        "score": 8,
        "definition": "Elite Health certification status in accordance with the Cattle Health Certification Standards (CHeCS) scheme operated by Biobest and PHCS"
      },
      {
        "score": 6,
        "definition": "Premium Health, with CHeCS certification and accreditation for with Johnes Level 2 or 3, IBR vaccinated and BvD."
      },
      {
        "score": 4,
        "definition": "Standard Health with CHeCS membership and accreditation for at least 1 of the 5 key diseases."
      },
      {
        "score": 2,
        "definition": "Health protocols and annual health, with the intention of seeking CHeCS accreditation"
      },
      {
        "score": 0,
        "definition": "No CHeCS health accreditation certification"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d0a": {
    "id": "5ed0e9a4f1ae202c11bb1d0a",
    "name": "Medication",
    "category": "production",
    "significance": "Early proportionate treatment of disease, to mitigate cross-infection risk, for animal welfare and reducing antibiotics resistance in humans.",
    "key": "medication",
    "scoreCard": [
      {
        "score": 4,
        "definition": "No medical intervention or illness"
      },
      {
        "score": 3,
        "definition": "Minor illness requiring some medical intervention, as prescribed by the Vet"
      },
      {
        "score": 2,
        "definition": "An Illness requiring  antibiotic treatment as prescribed by the Vet. Successful recovery"
      },
      {
        "score": 1,
        "definition": "Antibiotics administered as a preventative treatment to raise immunity, as used in dairy calf units"
      },
      {
        "score": 0,
        "definition": "On farm medication on a self-assessed basis with no formal medical records"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d0b": {
    "id": "5ed0e9a4f1ae202c11bb1d0b",
    "name": "Breed",
    "category": "eating",
    "significance": "British suckler beef native breeds and their genetic traits are renowned world-wide, for taste and succulence.",
    "key": "breed",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Pedigree-registered native British Suckler Beef breed, recorded in Breedplan or a similar genetic traits-measuring and certification regime "
      },
      {
        "score": 3,
        "definition": "Pedigree-registered and authenticated Suckler Beef animal of any breed, recorded in Breedplan or similar for genetic traits-measuring, comparison and certification regime "
      },
      {
        "score": 2,
        "definition": "Hybrid Suckler Beef animal with genetics based on 2 or more identified beef breeds in the Animal Passport.  No authenticated ancestry"
      },
      {
        "score": 1,
        "definition": "Dairy cow, crossed with a pedigree-registered and authenticated Suckler Beef bull, including ancestry"
      },
      {
        "score": 0,
        "definition": "Cross-bred with loosely identified breeds, but no formally authenticated ancestry"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d0c": {
    "id": "5ed0e9a4f1ae202c11bb1d0c",
    "name": "Home Bred",
    "category": "eating",
    "significance": "Closed herd with no cattle stock movements, for minimising food miles and for avoiding stress-related gristle",
    "key": "homeBred",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Born and raised the same farm, which operates a closed herd.  Authenticated via the BCMS Animal Passport and Identification Tag"
      },
      {
        "score": 3,
        "definition": "1 movement from the breeding farm after weaning for finishing or breeding. Authenticated via the BCMS Animal Passport and Identification Tag "
      },
      {
        "score": 2,
        "definition": "2 movements post weaning. Authenticated via the BCMS Animal Passport  and Identification Tag"
      },
      {
        "score": 1,
        "definition": "3 or more movements. Authenticated via the BCMS Animal Passport and Identification Tag"
      },
      {
        "score": 0,
        "definition": "Foreign or unknown origin"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d0d": {
    "id": "5ed0e9a4f1ae202c11bb1d0d",
    "name": "Pasture Fed",
    "category": "eating",
    "significance": "Pasture-based diet, for producing beef with a higher nutritional quotient, for benefits to human health",
    "key": "pastureFed",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Full Pasture for Life (PLFA) certification to authenticate a 100% pasture-based diet, and the nutritional value benefits including Omega 3 to 6 ratio, Vitamins A, E & B12, Anti-oxidants, CLA and minerals"
      },
      {
        "score": 3,
        "definition": "100% pasture-based diet, for beneficial nutrients, but not certified under Pasture for Life or other recognised certification body."
      },
      {
        "score": 2,
        "definition": "70% pasture-based diet, with some beneficial impact of Omega 3 to 6 ratio and carbon sequestration capacity."
      },
      {
        "score": 1,
        "definition": "50% pasture-based diet which is the minimum level set by Defra to be regarded as grass-fed, with some of nutritional benefits and carbon sequestration."
      },
      {
        "score": 0,
        "definition": "Intensive feed regime, based on a grain, soya and bi-products manufactured feed diet, with a significant carbon footprint and Omega 6 imbalance from grain."
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d0e": {
    "id": "5ed0e9a4f1ae202c11bb1d0e",
    "name": "Flavour & Taste",
    "category": "eating",
    "significance": "A combination of genetic (eg. fat cover and marbling) characteristics, feed regime , maturity and husbandry, giving beef taste and succulence, for the eater",
    "key": "flavour",
    "scoreCard": [
      {
        "score": 4,
        "definition": "<Fragment><span className=\"highlight\">Supreme:</span> 6-8% intra-muscular fat (IMF).  On-farm predictive Ultra-Sound IMF (Marbling) measurement by an independant service provider</Fragment> "
      },
      {
        "score": 3,
        "definition": "<Fragment><span className=\"highlight\">Prime:</span> 4-5% intra-muscular fat (IMF).  On-farm predictive Ultra-Sound IMF (Marbling) measurement by an independant service provider</Fragment> "
      },
      {
        "score": 2,
        "definition": "<Fragment><span className=\"highlight\">Classic:</span> 2-3% intra-muscular fat (IMF).  On-farm predictive Ultra-Sound IMF (Marbling) measurement by an independent service provider.</Fragment> "
      },
      {
        "score": 1,
        "definition": "<Fragment><span className=\"highlight\">Superior:</span> 1% intra-muscular fat (IMF).  On-farm predictive Ultra-Sound IMF (Marbling) measurement by an independent service provider.</Fragment> "
      },
      {
        "score": 0,
        "definition": "<Fragment><span className=\"highlight\">Standard:</span> No available on-farm predictive measures for marbling (IMF) before slaughter.</Fragment>"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d0f": {
    "id": "5ed0e9a4f1ae202c11bb1d0f",
    "name": "Texture & Tenderness",
    "category": "eating",
    "significance": "A combination of genetic (eg. fat cover and marbling) characteristics, feed regime , maturity and husbandry, giving beef a sense of softness and chewiness, for the eater",
    "key": "texture",
    "scoreCard": [
      {
        "score": 4,
        "definition": "<Fragment><span className=\"highlight\">Supreme:</span> 6-8% intra-muscular fat (IMF). On-farm predictive ultra-sound IMF (Marbling)  measurement by an independent service provider. Dry Hung for 28+ days</Fragment> "
      },
      {
        "score": 3,
        "definition": "<Fragment><span className=\"highlight\">Prime:</span> 4-5% intra-muscular fat (IMF). On-farm predictive ultra-sound IMF (Marbling) measurement by an independent service provider. Dry Hung for 21+ days</Fragment> "
      },
      {
        "score": 2,
        "definition": "<Fragment><span className=\"highlight\">Classic:</span> 2-3% intra-muscular fat (IMF). On-farm predictive ultra-sound IMF (Marbling) measurement by an independent service provider.  Dry Hung for 14+ days</Fragment> "
      },
      {
        "score": 1,
        "definition": "<Fragment><span className=\"highlight\">Superior:</span> 1% intra-muscular fat (IMF). On-farm predictive ultra-sound IMF (Marbling) measurement by an independent service provider. Dry Hung for 8+ days</Fragment> "
      },
      {
        "score": 0,
        "definition": "<Fragment><span className=\"highlight\">Standard:</span> No available on-farm predictive measures for marbling (IMF) before slaughter. Wet Aged (ie. after vacuum packing)</Fragment>"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d10": {
    "id": "5ed0e9a4f1ae202c11bb1d10",
    "name": "Fat Cover",
    "category": "eating",
    "significance": "Fat cover for promoting essential bio-active substances and essential nutrients",
    "key": "fatCover",
    "scoreCard": [
      {
        "score": 4,
        "definition": "<Fragment><span className=\"highlight\">Supreme:</span> 7-8cm average fat depth at Rump (P8) and Rib (12/13 Rib) and Top 10% genetic ranking. On-farm predictive Ultra-Sound measurement</Fragment> "
      },
      {
        "score": 3,
        "definition": "<Fragment><span className=\"highlight\">Prime:</span> 5-6cm average fat depth at Rump (P8) and Rib (12/13 Rib) and Higher genetic ranking from Breedplan. On-farm predictive Ultra-Sound measurement.</Fragment> "
      },
      {
        "score": 2,
        "definition": "<Fragment><span className=\"highlight\">Classic:</span> 4cm average fat depth at Rump (P8) and Rib (12/13 Rib) and Average genetic ranking from on-farm predictive Ultra-Sound measurement</Fragment> "
      },
      {
        "score": 1,
        "definition": "<Fragment><span className=\"highlight\">Superior:</span> 3cm average fat depth at Rump (P8) and Rib (12/13 Rib) and in the Lower genetic ranking from on-farm predictive Ultra-Sound IMF measurement.</Fragment> "
      },
      {
        "score": 0,
        "definition": "<Fragment><span className=\"highlight\">Standard:</span> 1-2cm average fat depth.  Lean Retail Value emphasis. Or, no ultra sound measurement techniques used and no available genetic rankings</Fragment>"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d11": {
    "id": "5ed0e9a4f1ae202c11bb1d11",
    "name": "West Country Beef PGI status",
    "category": "eating",
    "significance": "Grass-fed cattle reared in the six counties of the South West of England, which has 30% of the UK's grassland, for distinctive flavour and nutritional value delivered naturally",
    "key": "pgiStatus",
    "scoreCard": [
      {
        "score": 4,
        "definition": "100% grass-fed cattle. Authentication by the Pasture for Life Association.  Born, raised and slaughtered in the West Country. Provenance authentication from Animal Passport"
      },
      {
        "score": 3,
        "definition": "West Country  Beef scheme - PGI (Protected Geographic Indication). Provenance authentication from Animal Passport. At least 85% grass-fed. Born, raised in the West Country."
      },
      {
        "score": 2,
        "definition": "West Country  Beef scheme - PGI (Protected Geographic Indication).  At least 75% grass-fed. Born, raised and slaughtered in the West Country. Provenance from Animal Passport."
      },
      {
        "score": 1,
        "definition": "West Country  Beef scheme - PGI (Protected Geographic Indication). At least 70% grass-fed. Born, raised and slaughtered in the West Country. Animal Passport authenticated."
      },
      {
        "score": 0,
        "definition": "Grass-fed. Born, raised and slaughtered in the West Country. Not approved members of the scheme."
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d12": {
    "id": "5ed0e9a4f1ae202c11bb1d12",
    "name": "Nutritional Value",
    "category": "eating",
    "significance": "A diet that includes red meat diet for providing many essential nutrients and a balanced Omega 3/Omega 6 \"good fat\" ratio of 1:4. (See GoodBeef Index Nutrition Value facts sheet).",
    "key": "nutritionalValue",
    "scoreCard": [
      {
        "score": 8,
        "definition": "100% Grass fed beef has high levels of Conjugated Linoleic Acid (CLA), Trans-Vaccenic Acid (TVA). It restores the Omega 3 to 6 balance and in doing so is a key factor in reducing obesity in humans."
      },
      {
        "score": 6,
        "definition": "Grass fed beef is rich in antioxidants CoQ10, Zinc, Vitamin B12 and glutathone for reducing cancer risk and premature aging; plus, Vitamin A for enhanced immune function and regulation of blood sugar levels."
      },
      {
        "score": 4,
        "definition": "Grass and grain fed beef generally has high levels of beta carotene, the precursor to Vitamin A which has tumour-supressing characteristics; and, Vitamin E for healthy skin and eyes - per NHS"
      },
      {
        "score": 2,
        "definition": "Beef possesses no anti-nutrients and is an important source of energy, protein, minerals and vitamins"
      },
      {
        "score": 0,
        "definition": "Soyabean and grain-based products are not an adequate alternative to beef. They possess anti-nutrients, have a concentration of estrogenic compounds and Phylic acid that obstructs mineral absorption."
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d13": {
    "id": "5ed0e9a4f1ae202c11bb1d13",
    "name": "Retail Value",
    "category": "eating",
    "significance": "Optimal rib-eye muscle area and Intramuscular fat (IMF) size for maximising the available beef and indicating carcass value",
    "key": "retailValue",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Eye muscle area 90+ sq. cm; in the top 10% genetic ranking for quantity of lean meat. On-farm ultra-sound measurement by an independent service provider"
      },
      {
        "score": 3,
        "definition": "Eye muscle area 80+ sq. cm; or in the top 30% genetic ranking. On-farm ultra-sound measurement by an independant service provider"
      },
      {
        "score": 2,
        "definition": "Eye muscle area 70+ sq. cm; average genetic ranking.  On-farm ultra-sound measurement by an independent service provider"
      },
      {
        "score": 1,
        "definition": "Eye muscle area 50+ sq. cm; lower genetic ranking. On-farm ultra-sound measurement by an independent service provider"
      },
      {
        "score": 0,
        "definition": "No Eye muscle area data available."
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d14": {
    "id": "5ed0e9a4f1ae202c11bb1d14",
    "name": "Carbon Sequestation",
    "category": "environment",
    "significance": "Adaptive Multi-Paddock Grazing (AMP) and 100% grass-fed, for reducing Green House Gases by a net 2 to 3 tonnes per animal over the life-cycle",
    "key": "carbonSequestation",
    "scoreCard": [
      {
        "score": 8,
        "definition": "Methodology for calculating the volume of GHG reduction attributable, based on 100% grass-fed and paddock grazing Approved scheme for carbon offsets with carbon emitting entities"
      },
      {
        "score": 6,
        "definition": "Pasture for Life (PFLA) certification for 100% pasture-fed, coupled with an adaptive multi-paddock (AMP) natural grazing solution.  Delivers 2-3 tonnes of GHG reduction per animal lifecycle, based on Michigan State University research."
      },
      {
        "score": 4,
        "definition": "Extensive strip grazing and 100% grass-fed diet system which is likely to have less CO2 emissions, depending on the precise method."
      },
      {
        "score": 2,
        "definition": "Feedlot intensive system, likely to emit 6.12Kg C02 per Kg of animal weight, according to research"
      },
      {
        "score": 0,
        "definition": "Traditional extensive grazing system, likely to emit 9.62Kg C02 per Kg of animal weight, according to Michigan State University research"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d15": {
    "id": "5ed0e9a4f1ae202c11bb1d15",
    "name": "Methane Mitigation",
    "category": "environment",
    "significance": "Optimal conversion of feed to energy, by re-directing rumen microbic activity, for reducing methane emissions",
    "key": "methaneMitigation",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Reducing the abundance of the flora in the rumen microbiome. Supressing the methane-producing microbes as per the Ben Gurian University research findings"
      },
      {
        "score": 3,
        "definition": "Smaller mature suckler cows weighing approximately 650Kg, coupled with smaller calves who have rapid growth characteristics and a weaned weight to dam ratio (WWD) of 40%+"
      },
      {
        "score": 2,
        "definition": "Large cows (750kg+) with a lower feed calf efficiency profile as evidenced by weaned calf growth efficiency ratio of less than 40% across the herd"
      },
      {
        "score": 1,
        "definition": "Very large cows 900Kg+ with heavy calves reared on a grain and concentrates supplements diet, early weaning and an intensive indoor finishing regime."
      },
      {
        "score": 0,
        "definition": "Low herd fertility (85% or less) and high calf mortality (5%+), coupled with large cows (750Kg+) which puts an additional burden on GHG emissions"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d16": {
    "id": "5ed0e9a4f1ae202c11bb1d16",
    "name": "Cropping for GHD Reduction",
    "category": "environment",
    "significance": "Inter-Cropping, Multi Cover and No-Till agricultural system for enhancing soil Carbon Sequestration of C02 and reducing synthetic N usage",
    "key": "croppingGhgReduction",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Crop rotation, intercropping, for AMP mob grazing and wholecrop, using winter vegetables, minimising synthetic N and storing soil organic Carbon Authentication via University of Florida research"
      },
      {
        "score": 3,
        "definition": "Growing a cereal, vetch and peas wholecrop for winter feed and grass undersown, plus over-seeding existing grazed swards with nitrogen-fixing plants, thereby reducing N requirement and soil disturbance"
      },
      {
        "score": 2,
        "definition": "Spreading straw based Farmyard Manure (FYM) for increasing the biomass accumulation and reducing synthetic fertilizer use"
      },
      {
        "score": 1,
        "definition": "Crop rotation with legumes for increasing soil productivity, biomass and sward quality, whilst decreasing weed"
      },
      {
        "score": 0,
        "definition": "Old grass leys, with use of synthetic N fertilizer to boost productivity"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d17": {
    "id": "5ed0e9a4f1ae202c11bb1d17",
    "name": "Soil Condition",
    "category": "environment",
    "significance": "Correct acidity/alkalinity, Phosphorus (P), Potassium (K) and Soil Organic Matter (SOM) levels for sustainable farming",
    "key": "soilCondition",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Soil make-up and fertiliser usage compliance with the Soil Association specification. Authentication via Soil Association Certification."
      },
      {
        "score": 3,
        "definition": "Annual soil analysis and treatment for a pH of 6-6.5. Keep P and K to 2+, Soil Organic Matter (SOM) 7.5%+. with a Farm Yard Manure programme. Improve Selenium level to 7 parts per million"
      },
      {
        "score": 2,
        "definition": "Soil analysis every 5 years or so and take action as deemed necessary."
      },
      {
        "score": 1,
        "definition": "Informal assessment of specific problem areas and action to be taken where prescribed."
      },
      {
        "score": 0,
        "definition": "No soil analysis done. Actions based on experience"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d18": {
    "id": "5ed0e9a4f1ae202c11bb1d18",
    "name": "Trace Elements and Mineral Levels",
    "category": "environment",
    "significance": "Sufficient levels of trace elements for maintaining cattle health and increasing fertility, milkiness and disease immunity",
    "key": "traceElements",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Annual analysis of trace elements and minerals in cattle and soil. Medicate drinking water to meet mineral and elements deficiencies. Authentication via test results and treatment records."
      },
      {
        "score": 3,
        "definition": "Annual analysis of trace elements and minerals in cattle and soil. Apply preventative medication, such as boluses, pour-ons and mineral licks"
      },
      {
        "score": 2,
        "definition": "Analysis of soil trace elements and minerals from a health problems perspective. Prescribe medication such as bolusing for any generally known deficiencies."
      },
      {
        "score": 1,
        "definition": "Prescribe medication, such as bolusing, mineral licks, pour-ons in response to observed health issues and poor performance"
      },
      {
        "score": 0,
        "definition": "No analysis of trace elements. Actions in response to abattoir and veterinary reporting"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d19": {
    "id": "5ed0e9a4f1ae202c11bb1d19",
    "name": "Pasture plant varieties",
    "category": "environment",
    "significance": "Seed Mixes and Swards with greater N-fixing capabilities from the air into ,the soil for reducing synthetic fertilizers and enhancing beef tastiness",
    "key": "plantVarieties",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Mix of 4 or more different grasses, red and white clovers, legume and herbal types, for sustaining a 21day paddock grazing rotation, without recourse to synthetic fertilisers"
      },
      {
        "score": 3,
        "definition": "Mix of 2 or more different grasses, red and white clovers, legume and herbal types, FYM fertilizing for sustaining paddock grass regeneration"
      },
      {
        "score": 2,
        "definition": "Mix of grasses with 10%+ clover and 10%+ of N fixing legumes and clovers. Occasional recourse to artificial N fertiliser up to 100Kg hectare per year in addition to FYM."
      },
      {
        "score": 1,
        "definition": "Permanent pasture with some weed ingress and 5-10% clover cover. Unable to support more than 4 rotations per year."
      },
      {
        "score": 0,
        "definition": "Low quality rough meadow grass, with 60-80% weed ingress supporting a traditional extensive grazing system."
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d1a": {
    "id": "5ed0e9a4f1ae202c11bb1d1a",
    "name": "Pasture vs Grain and Soya",
    "category": "environment",
    "significance": "Optimal Pasture use, as nature's ruminants' feed solution, for increasing grain and soya for human consumption.",
    "key": "pastureVsGrain",
    "scoreCard": [
      {
        "score": 4,
        "definition": "100% Pasture fed, in accordance with the Pasture for Life Association certification standards"
      },
      {
        "score": 3,
        "definition": "70% grass-fed, in accordance with the South West Beef PGI certification standards"
      },
      {
        "score": 2,
        "definition": "51% Grass-fed, in accordance with Defra minimum standard for \"grass-fed\" appellation"
      },
      {
        "score": 1,
        "definition": "Intensively farmed beef, based on some grazing, with an indoor grain, soya and allowable waste products diet mix"
      },
      {
        "score": 0,
        "definition": "Ad Lib Grain and Soya-based finishing diets, resulting in net GHG emissions, with high \"food miles\" for UK beef production."
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d1b": {
    "id": "5ed0e9a4f1ae202c11bb1d1b",
    "name": "Medication - Antibiotics",
    "category": "environment",
    "significance": "Control the level of antibiotics used, for reducing bacterial antibiotic resistance in humans ",
    "key": "antibiotics",
    "scoreCard": [
      {
        "score": 4,
        "definition": "Not prescribed or used for animal.  Full compliance with antibiotics best practice for cattle.  Authentication via Farm Medical Records"
      },
      {
        "score": 3,
        "definition": "Used  in response to a specific animal illness as prescribed by a qualified vet.  Full compliance with antibiotics best practice for cattle.  Authentication via Farm Medical Records"
      },
      {
        "score": 2,
        "definition": "Regularly used as a herd response to recurrent outbreaks of bacterial disease and as prescribed by a vet"
      },
      {
        "score": 1,
        "definition": "Routinely used as a herd to boost immunity in dairy calves who are separated at an early age from their dam"
      },
      {
        "score": 0,
        "definition": "Added to feed for promoting faster growth. No longer permitted in the US"
      }
    ],
    "saved": true
  },
  "5ed0e9a4f1ae202c11bb1d1c": {
    "id": "5ed0e9a4f1ae202c11bb1d1c",
    "name": "Water Harvesting",
    "category": "environment",
    "significance": "Reduce Mains Water dependence with rain water collection and aquifers for increasing human water supply availability",
    "key": "waterQuality",
    "scoreCard": [
      {
        "score": 4,
        "definition": "100% farm harvested, filtered and mineralised water supply to compensate for trace element and mineral shortfalls. Authentication via Liquid Minerals Services surveillance technologies"
      },
      {
        "score": 3,
        "definition": "50% farm-harvested, filtered and mineralised water supply to compensate for trace element and mineral shortfalls. Authentication via Liquid Minerals Services surveillance technologies"
      },
      {
        "score": 2,
        "definition": "80% Mains water supply, coupled with bolusing to compensate for trace element and mineral shortfalls."
      },
      {
        "score": 1,
        "definition": "100% reliant on Mains Water supply. Some bolusing for minerals deficiencies"
      },
      {
        "score": 0,
        "definition": "Water supply from ponds, streams and rivers shared with other livestock, without filtration and mineralisation"
      }
    ],
    "saved": true
  }
};

export default defaultScores;
